import { useCallback, useEffect, useState } from 'react';
import Container from 'components/common/Container';
import { jsonAxios } from 'components/axios';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { INotiDetail } from 'types/noti';
import PageTemplate from 'components/template/PageTemplate';
import Bg1 from 'assets/mypage/notice.avif'
import { ReactComponent as Back } from 'assets/notice/back.svg'
import { ReactComponent as Next } from 'assets/notice/next.svg'
import { bytesToMB, download } from 'components/function';
import { ReactComponent as Down } from 'assets/header/download.svg'
import { ReactComponent as File } from 'assets/header/file.svg'
import CustomButton from 'components/common/CustomButton';
import { toast } from 'react-toastify';

const NoticeDetail = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const location = useLocation();
    const id = searchParams.get('id');
    const [data, setData] = useState<INotiDetail>({} as INotiDetail);

    const getNoticeList = useCallback(() => {
        if (!id) {
            toast.error('잘못된 경로입니다.');
            setTimeout(() => {
                navigate(-1);
            }, 500);
            return;
        }
        jsonAxios.get(`notice/${id}${location.state ? `?search=${location.state}` : ''}`).then(res => {
            console.log(res.data)
            if (res.data.code === 200) {
                setData(res.data.data)
            }
            else if (res.data.code === 401) {
                toast.error('존재하지 않는 공지사항입니다.')
                navigate(-1)
            }
        })
    }, [id]);

    useEffect(() => {
        getNoticeList();
    }, [getNoticeList])

    return (
        <PageTemplate background='bg-[#F8F8FA]'>
            <div
                className="relative flex justify-center items-center bg-primary bg-cover h-60 mobile:h-30 text-white"
                style={{
                    backgroundPosition: "center",
                    backgroundImage: `url(${Bg1})`,
                }}
            >
                <div className='flex flex-col justify-center items-center gap-2'>
                    <p className='font-semibold text-32 tablet:text-2xl'>공지사항</p>
                    <p className='tablet:text-lg text-2xl'>{data.createAt}</p>
                </div>
            </div>
            <div className='flex flex-col gap-25 h-full select-text'>
                <Container className="flex flex-col gap-6 py-10">
                    <div className='flex flex-col gap-3 bg-white rounded-xl w-full'>
                        <div className='flex justify-between items-center mobile:p-6 px-10 tablet:px-4 py-6 border-b'>
                            <p className='font-semibold text-2xl'>{data.title}</p>
                            <p className='text-[#9D9EB7] text-2xl'>{data.createAt}</p>
                        </div>
                        <div className='flex flex-col justify-between gap-10 p-10 h-full min-h-[400px] overflow-y-auto'>
                            <div className='flex-1' dangerouslySetInnerHTML={{ __html: data?.content }} />
                            <div className='flex flex-col gap-3'>
                                {
                                    data.fileInfo &&
                                    data.fileInfo.map((item, idx) => (
                                        <div className='flex justify-between items-center bg-[#F8F8FA] px-6 mobile:px-3 py-2.5 rounded-lg h-20 mobile:h-10 cursor-pointer' key={idx} onClick={() => {
                                            download(item.filePath)
                                        }}>
                                            <div className='flex justify-center items-center pr-6 mobile:pr-3 border-r h-full'>
                                                <File className='mobile:w-4' />
                                            </div>
                                            <p className='pl-6 mobile:pl-3 w-full font-semibold text-[#9D9EB7] mobile:text-sm text-lg text-left mobile:truncate'>{item.fileName} ({bytesToMB(item.fileSize)})</p>
                                            <div className='px-6 mobile:px-3'><Down /></div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                    <div className='flex justify-between items-center gap-3'>
                        <div className='flex-1'>
                            {
                                data.prevId > 0 &&
                                <CustomButton
                                    className='bg-white !text-black hover:!text-white'
                                    title='이전'
                                    Icon={Back}
                                    onClick={() => {
                                        navigate(`/mypage/notice/detail?id=${data.prevId}`, { state: location.state })
                                    }}
                                />
                            }
                        </div>
                        <CustomButton
                            className='flex-[3.0] bg-primary max-w-[600px]'
                            title='공지사항 목록이동'
                            onClick={() => {
                                navigate('/mypage/notice/list', { replace: true })
                            }}
                        />
                        <div className='flex flex-1 justify-end'>
                            {
                                data.nextId > 0 &&
                                <CustomButton
                                    className='bg-white !text-black hover:!text-white'
                                    title='다음'
                                    iconReverse
                                    Icon={Next}
                                    onClick={() => {
                                        navigate(`/mypage/notice/detail?id=${data.nextId}`, { state: location.state })
                                    }}
                                />
                            }
                        </div>
                    </div>
                </Container>
            </div>
        </PageTemplate>
    )
}

export default NoticeDetail